/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "wingi",
        "0": "dino iki",
        "1": "sesuk",
        "future": {
          "other": "ing {0} dina"
        },
        "past": {
          "other": "{0} dina kepungkur"
        }
      },
      "day-narrow": {
        "-1": "wingi",
        "0": "dino iki",
        "1": "sesuk",
        "future": {
          "other": "ing {0} dina"
        },
        "past": {
          "other": "{0} dino kepungkur"
        }
      },
      "day-short": {
        "-1": "wingi",
        "0": "dino iki",
        "1": "sesuk",
        "future": {
          "other": "ing {0} dina"
        },
        "past": {
          "other": "{0} dina kepungkur"
        }
      },
      "hour": {
        "0": "jam iki",
        "future": {
          "other": "ing {0} jam"
        },
        "past": {
          "other": "{0} jam kepungkur"
        }
      },
      "hour-narrow": {
        "0": "jam iki",
        "future": {
          "other": "ing {0} jam"
        },
        "past": {
          "other": "{0} jam kepungkur"
        }
      },
      "hour-short": {
        "0": "jam iki",
        "future": {
          "other": "ing {0} jam"
        },
        "past": {
          "other": "{0} jam kepungkur"
        }
      },
      "minute": {
        "0": "menit iki",
        "future": {
          "other": "ing {0} menit"
        },
        "past": {
          "other": "{0} menit kepungkur"
        }
      },
      "minute-narrow": {
        "0": "menit iki",
        "future": {
          "other": "ing {0} menit"
        },
        "past": {
          "other": "{0} menit kepungkur"
        }
      },
      "minute-short": {
        "0": "menit iki",
        "future": {
          "other": "ing {0} menit"
        },
        "past": {
          "other": "{0} menit kepungkur"
        }
      },
      "month": {
        "-1": "sasi wingi",
        "0": "sasi iki",
        "1": "sasi ngarep",
        "future": {
          "other": "ing {0} sasi"
        },
        "past": {
          "other": "{0} sasi kepungkur"
        }
      },
      "month-narrow": {
        "-1": "sasi wingi",
        "0": "sasi iki",
        "1": "sasi ngarep",
        "future": {
          "other": "ing {0} sasi"
        },
        "past": {
          "other": "{0} sasi kepungkur"
        }
      },
      "month-short": {
        "-1": "sasi wingi",
        "0": "sasi iki",
        "1": "sasi ngarep",
        "future": {
          "other": "ing {0} sasi"
        },
        "past": {
          "other": "{0} sasi kepungkur"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "triwulan wingi",
        "0": "triwulan iki",
        "1": "triwulan ngarep",
        "future": {
          "other": "ing {0} triwulan"
        },
        "past": {
          "other": "{0} triwulan kepungkur"
        }
      },
      "quarter-narrow": {
        "-1": "triwulan wingi",
        "0": "triwulan iki",
        "1": "triwulan ngarep",
        "future": {
          "other": "ing {0} triwulan"
        },
        "past": {
          "other": "{0} triwulan kepungkur"
        }
      },
      "quarter-short": {
        "-1": "triwulan wingi",
        "0": "triwulan iki",
        "1": "triwulan ngarep",
        "future": {
          "other": "ing {0} triwulan"
        },
        "past": {
          "other": "{0} triwulan kepungkur"
        }
      },
      "second": {
        "0": "saiki",
        "future": {
          "other": "ing {0} detik"
        },
        "past": {
          "other": "{0} detik kepungkur"
        }
      },
      "second-narrow": {
        "0": "saiki",
        "future": {
          "other": "ing {0} detik"
        },
        "past": {
          "other": "{0} detik kepungkur"
        }
      },
      "second-short": {
        "0": "saiki",
        "future": {
          "other": "ing {0} detik"
        },
        "past": {
          "other": "{0} detik kepungkur"
        }
      },
      "week": {
        "-1": "pekan wingi",
        "0": "pekan iki",
        "1": "pekan ngarep",
        "future": {
          "other": "ing {0} pekan"
        },
        "past": {
          "other": "{0} pekan kepungkur"
        }
      },
      "week-narrow": {
        "-1": "pkn wingi",
        "0": "pkn iki",
        "1": "pkn ngarep",
        "future": {
          "other": "ing {0} pekan"
        },
        "past": {
          "other": "{0} pekan kepungkur"
        }
      },
      "week-short": {
        "-1": "pkn wingi",
        "0": "pkn iki",
        "1": "pkn ngarep",
        "future": {
          "other": "ing {0} pekan"
        },
        "past": {
          "other": "{0} pekan kepungkur"
        }
      },
      "year": {
        "-1": "taun wingi",
        "0": "taun iki",
        "1": "taun ngarep",
        "future": {
          "other": "ing {0} taun"
        },
        "past": {
          "other": "{0} taun kepungkur"
        }
      },
      "year-narrow": {
        "-1": "taun wingi",
        "0": "taun iki",
        "1": "taun ngarep",
        "future": {
          "other": "ing {0} taun"
        },
        "past": {
          "other": "{0} taun kepungkur"
        }
      },
      "year-short": {
        "-1": "taun wingi",
        "0": "taun iki",
        "1": "taun ngarep",
        "future": {
          "other": "ing {0} taun"
        },
        "past": {
          "other": "{0} taun kepungkur"
        }
      }
    },
    "locale": "jv"
  });
}